<div class="access-denied-container">
  <div class="content-wrapper">
    <div class="lock-icon">
      <div class="lock-body"></div>
      <div class="lock-shackle"></div>
    </div>

    <h1 class="title">Access Denied</h1>
    <p class="message">You do not have permission to axcess this page.</p>

    <button class="go-back-btn" (click)="goBack()">
      Go Back
    </button>
  </div>
</div>